import { render } from "./body_main_banner1.vue?vue&type=template&id=68dc3f50&scoped=true"
import script from "./body_main_banner1.vue?vue&type=script&lang=js"
export * from "./body_main_banner1.vue?vue&type=script&lang=js"

import "./body_main_banner1.vue?vue&type=style&index=0&id=68dc3f50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68dc3f50"]])

export default __exports__